import React, { Component } from 'react'
import { Row, Col, Card, Table, Button, Container, Form, Modal } from "react-bootstrap";
import moment from 'moment';

class MaterialStudentDetailsModal extends Component {
    render() {

        const { rowData } = this.props.stateData;

        if (!rowData || !rowData.total_quantity) {
            return null;
        }

        const { totalQuantityData } = rowData;

        console.log("hnnnnnn",this.props.stateData.rowData.totalQuantityData)

        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="modal-title">Material Quantity Details</Modal.Title>
                </Modal.Header>
                <Container fluid>
                    <Modal.Body className="p-4">
                        <Row>
                            <Col lg={12} md={12} sm={12} className='mt-3'>
                                <Table className="table  table-bordered table-hover ">
                                    <thead style={{ backgroundColor: "#213046", color: "#ffffff", textAlign: "center" }}>

                                        <tr>
                                            <th>Sno</th>
                                            <th>Material Name</th>
                                            <th>Material Quantity</th>
                                            <th>Date</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ backgroundColor: "", textAlign: "center" }}>
                                        {totalQuantityData.map((item, index) => (
                                            <tr key={index} className="tableBody">
                                                <td>{index + 1}</td>
                                                <td>{rowData.material_name}</td>
                                                <td>{item.material_count}</td>
                                                <td>{moment.unix(item.material_received_date).format("DD/MM/YYYY")}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </Modal.Body>
                </Container>

            </Modal>
        )
    }
}

export default MaterialStudentDetailsModal